var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOutlookcalendar = function SvgOutlookcalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M28 13h14.533c.81 0 1.467.657 1.467 1.467v19.066c0 .81-.657 1.467-1.467 1.467H28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28 17.958h14V33.5H28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M27 44 4 39.5v-31L27 4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.25 16.5c-3.176 0-5.75 3.358-5.75 7.5s2.574 7.5 5.75 7.5S21 28.142 21 24s-2.574-7.5-5.75-7.5m-.25 12c-1.657 0-3-2.015-3-4.5s1.343-4.5 3-4.5 3 2.015 3 4.5-1.343 4.5-3 4.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M28.047 29.737h2.7v2.9h-2.7zM31.448 29.737h2.7v2.9h-2.7zM34.849 29.737h2.7v2.9h-2.7zM28.047 26.159h2.7v2.9h-2.7zM31.448 26.159h2.7v2.9h-2.7zM34.849 26.159h2.7v2.9h-2.7zM38.25 26.159h2.7v2.9h-2.7zM28.047 22.706h2.7v2.9h-2.7zM31.448 22.706h2.7v2.9h-2.7zM34.849 22.706h2.7v2.9h-2.7zM38.25 22.706h2.7v2.9h-2.7zM31.448 19.112h2.7v2.9h-2.7zM34.849 19.112h2.7v2.9h-2.7zM38.25 19.112h2.7v2.9h-2.7z"
  })));
};
export default SvgOutlookcalendar;